export default __webpack_public_path__ + "static/media/find-next.1ccd3fd1.svg";